import { StaticContent as StaticContentType } from 'types/interface';
import { PageProps } from 'types/types';
import StaticContent, {
  loadStaticContent,
} from 'components/_shared/widgets/static-content';
import { canonicalUrl } from '../util/url';
import { GetStaticPropsResult } from 'next';

const CONTENT_SLUG = 'about-us';

interface AboutUsPageProps {
  content: StaticContentType;
}

const Page = (props: AboutUsPageProps) => (
  <StaticContent contentSlug={CONTENT_SLUG} {...props} />
);

export async function getStaticProps(): Promise<
  GetStaticPropsResult<PageProps & AboutUsPageProps>
> {
  const content = loadStaticContent(CONTENT_SLUG);
  return {
    props: {
      content,
      layout: {
        metaTags: { ...content.meta, canonical: canonicalUrl(CONTENT_SLUG) },
      },
    },
  };
}

export default Page;
